import { createAsyncThunk } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

// My Workspace → Tutor Replacement Tracker. The TA head, TA associate and CRO pages keep their rows in local state
// (they share one list endpoint), so these are plain thunks with no reducer.

const fetchTrackerList = (params, signal) =>
  apiRequest({
    method: 'get',
    url: `tutor-replacement-tracker?${new URLSearchParams(params)}`,
    signal,
  });

export const getTrackerAccess = createAsyncThunk('tutorReplacementTracker/getAccess', (_, { signal }) =>
  apiRequest({ method: 'get', url: 'tutor-replacement-tracker/access', signal }),
);

export const getTrackerList = createAsyncThunk('tutorReplacementTracker/getList', (params, { signal }) =>
  fetchTrackerList(params, signal),
);

// GlobalTable export: same filters with limit=no
export const exportTrackerList = createAsyncThunk('tutorReplacementTracker/exportList', (params) =>
  fetchTrackerList(params),
);

export const assignTrackerRows = createAsyncThunk('tutorReplacementTracker/assign', (data) =>
  apiRequest({ method: 'post', url: 'tutor-replacement-tracker/assign', data }),
);

export const updateTrackerProgress = createAsyncThunk('tutorReplacementTracker/updateProgress', ({ trainerAssignmentId, ...data }) =>
  apiRequest({ method: 'post', url: `tutor-replacement-tracker/${trainerAssignmentId}/progress`, data }),
);

export const getTrackerHistory = createAsyncThunk('tutorReplacementTracker/getHistory', (trainerAssignmentId) =>
  apiRequest({ method: 'get', url: `tutor-replacement-tracker/${trainerAssignmentId}/history` }),
);

// Dashboard → Tutor Replacement Analytics (anyone): project / CRO / TA head / TA associate breakdowns
export const getTrackerAnalytics = createAsyncThunk('tutorReplacementTracker/getAnalytics', (params, { signal }) =>
  apiRequest({ method: 'get', url: `tutor-replacement-tracker/analytics?${new URLSearchParams(params)}`, signal }),
);
